import React__default, { useState, useEffect } from 'react';
import { useIsomorphicLayoutEffect } from '../use-isomorphic-layout-effect/use-isomorphic-layout-effect.js';

/* eslint-disable react-hooks/rules-of-hooks */
var csr = false;
var counter = 0;
var defaultPrefix = 'nova-component';

function generateId(prefix) {
  return "" + prefix + ++counter;
}

function resetId() {
  counter = 0;
} // @ts-ignore

var reactUseId = 'useId' in React__default ? React__default.useId : undefined;
function useComponentId(_ref) {
  var _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? defaultPrefix : _ref$prefix;

  if (reactUseId !== undefined) {
    var generatedId = reactUseId();
    return generatedId.slice(1).slice(0, generatedId.length - 2);
  }

  var initialId = csr ? generateId(prefix) : null;

  var _useState = useState(initialId),
      id = _useState[0],
      setId = _useState[1];

  useIsomorphicLayoutEffect(function () {
    if (id === null) setId(generateId(prefix));
  }, []);
  useEffect(function () {
    if (!csr) csr = true;
  }, []);
  return id != null ? id : '';
}

export { resetId, useComponentId };
